module.exports = __webpack_public_path__ + "img/archive-icon.f2ecc48a.svg";